import { Box, Grid, GridSize, makeStyles, Theme } from '@material-ui/core';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import clsx from 'clsx';
import React, { FC } from 'react';

interface FeatureBoxProps extends Partial<Record<Breakpoint, boolean | GridSize>> {
  className?: string;
}
const useStyles = makeStyles((theme: Theme) => ({
  fullWidthBoxImage: {
    backgroundColor: theme.palette.switchedColors.whiteGray,
    borderRadius: theme.spacing(4),
    minHeight: '100%',
    padding: theme.spacing(8, 6, 4),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(12, 8, 6),
    },
  },
}));

const FeatureBox: FC<FeatureBoxProps> = ({ className, children, ...props }) => {
  const classes = useStyles();

  return (
    <Grid item {...props}>
      <Box className={clsx(classes.fullWidthBoxImage, className)}>{children}</Box>
    </Grid>
  );
};

export default FeatureBox;
